
export default function Products() {
  return (
    <div className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-6">
            <span className="text-xs font-semibold text-blue-800 tracking-wider uppercase">
              Our Products
            </span>
          </div>
          <h3 className="text-5xl font-bold text-gray-900">VPN & Cleaner Solutions</h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-product-shop>
          <div className="lg:col-span-3">
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl shadow-xl p-12 h-full">
              <div className="mb-8">
                <span className="text-sm font-bold text-blue-600 uppercase tracking-wide">VPN</span>
              </div>
              <div className="flex items-center justify-center mb-8">
                <img
                  src="https://public.readdy.ai/ai/img_res/e9e7e326a6c7ee7db3c780929e9298a9.jpg"
                  alt="VPN Product"
                  className="w-64 h-64 object-contain"
                />
              </div>
              <h4 className="text-3xl font-bold text-gray-900 mb-4">Secure Connection</h4>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our VPN application provides robust encryption and secure browsing capabilities, ensuring your online privacy and protecting your data from potential threats. Experience seamless connectivity with servers worldwide.
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-8">
            <div className="bg-gradient-to-br from-green-50 to-white rounded-3xl shadow-xl p-10">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-brush-line text-3xl text-white"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Device Optimization</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Clean junk files and cache</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Optimize device performance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Free up storage space</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-3xl shadow-lg p-10">
              <h4 className="text-xl font-semibold text-gray-900 mb-4">Expert Team</h4>
              <p className="text-gray-600 leading-relaxed">
                Our experienced developers and security experts work tirelessly to deliver applications that set industry standards for quality and reliability.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
